import {useEffect,useState} from 'react';

function CurrentYear() {
  const [year,setYear]=useState(new Date().getFullYear());

  useEffect(()=> {
    const update=()=> setYear(new Date().getFullYear());
    update();
    const id=setInterval(update,60 * 60 * 1000);
    return ()=> clearInterval(id);
  },[]);

  return <>{year}</>;
}

export default CurrentYear;